<template>
  <div v-if="!isLogin">
    <LoginPanel @login-success="onLoginSuccess" />
  </div>
  <div v-else id="app" class="app-wrap">
    <aside class="sidebar">
      <div class="brand">
        <img class="brand-logo" src="/monitor-logo.svg" alt="logo" />
        <span>竞品价格监控</span>
      </div>
      <div
        v-for="item in menus"
        :key="item.key"
        class="menu-item"
        :class="{ active: activeMenu === item.key }"
        @click="activeMenu = item.key"
      >
        {{ item.label }}
      </div>
    </aside>
    <main class="main">
      <header class="main-header">
        <h2>{{ currentLabel }}</h2>
        <div class="header-actions">
          <button class="change-pwd-btn" @click="openChangePassword">修改密码</button>
          <button class="logout-btn" @click="logout">退出登录</button>
        </div>
      </header>
      <section class="main-body">
        <component :is="currentView"></component>
      </section>
    </main>
    <div v-if="showChangePasswordModal" class="modal-mask" @click.self="closeChangePassword">
      <div class="modal-card">
        <h3>修改密码</h3>
        <label>旧密码</label>
        <input v-model.trim="passwordForm.old_password" type="password" placeholder="请输入旧密码" />
        <label>新密码</label>
        <input v-model.trim="passwordForm.new_password" type="password" placeholder="至少6位" />
        <label>确认新密码</label>
        <input v-model.trim="passwordForm.confirm_password" type="password" placeholder="再次输入新密码" />
        <div class="modal-actions">
          <button @click="closeChangePassword">取消</button>
          <button class="primary-btn" @click="submitChangePassword">确认修改</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MerchantManager from './views/priceMonitor/MerchantManager.vue'
import QuoteEntry from './views/priceMonitor/QuoteEntry.vue'
import LowestStats from './views/priceMonitor/LowestStats.vue'
import ComparePanel from './views/priceMonitor/ComparePanel.vue'
import OperationLogs from './views/priceMonitor/OperationLogs.vue'
import LoginPanel from './views/priceMonitor/LoginPanel.vue'
import { authChangePassword, authLogout } from './api/priceMonitor'

export default {
  name: 'App',
  components: {
    LoginPanel,
    MerchantManager,
    QuoteEntry,
    LowestStats,
    ComparePanel,
    OperationLogs
  },
  data() {
    return {
      isLogin: !!localStorage.getItem('accessToken'),
      activeMenu: 'merchant',
      showChangePasswordModal: false,
      passwordForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      menus: [
        { key: 'merchant', label: '商家管理', view: 'MerchantManager' },
        { key: 'quote', label: '报价录入', view: 'QuoteEntry' },
        { key: 'stats', label: '最低价看板', view: 'LowestStats' },
        { key: 'compare', label: '我方差价对比', view: 'ComparePanel' },
        { key: 'logs', label: '操作日志', view: 'OperationLogs' }
      ]
    }
  },
  mounted() {
    document.title = '竞品价格监控'
  },
  methods: {
    resetPasswordForm() {
      this.passwordForm = { old_password: '', new_password: '', confirm_password: '' }
    },
    openChangePassword() {
      this.showChangePasswordModal = true
      this.resetPasswordForm()
    },
    closeChangePassword() {
      this.showChangePasswordModal = false
      this.resetPasswordForm()
    },
    async submitChangePassword() {
      if (!this.passwordForm.old_password || !this.passwordForm.new_password || !this.passwordForm.confirm_password) {
        alert('旧密码、新密码、确认密码不能为空')
        return
      }
      if (this.passwordForm.new_password.length < 6) {
        alert('新密码长度不能少于6位')
        return
      }
      if (this.passwordForm.new_password !== this.passwordForm.confirm_password) {
        alert('两次输入的新密码不一致')
        return
      }
      const res = await authChangePassword(this.passwordForm)
      if (res.code !== 200) {
        alert(res.msg || '修改密码失败')
        return
      }
      alert(res.msg || '密码修改成功，请重新登录')
      this.closeChangePassword()
      await this.logout()
    },
    onLoginSuccess() {
      this.isLogin = true
    },
    async logout() {
      await authLogout()
      localStorage.removeItem('accessToken')
      localStorage.removeItem('pm_user')
      this.isLogin = false
    }
  },
  computed: {
    currentMenu() {
      return this.menus.find(item => item.key === this.activeMenu) || this.menus[0]
    },
    currentLabel() {
      return this.currentMenu.label
    },
    currentView() {
      return this.currentMenu.view
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
}
.app-wrap {
  min-height: 100vh;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #1f2937;
}
.sidebar {
  width: 220px;
  background: #111827;
  color: #fff;
  padding: 16px 12px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  margin-bottom: 10px;
}
.brand-logo {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}
.menu-item {
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  background: transparent;
}
.menu-item:hover {
  background: rgba(255, 255, 255, 0.12);
}
.menu-item.active {
  background: #2563eb;
}
.main {
  flex: 1;
  background: #f3f4f6;
}
.main-header {
  height: 64px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}
.main-header h2 {
  margin: 0;
  font-size: 20px;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.change-pwd-btn,
.logout-btn {
  height: 34px;
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 0 12px;
  cursor: pointer;
}
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.modal-card {
  width: 360px;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.modal-card h3 {
  margin: 0 0 6px;
}
.modal-card input {
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 10px;
}
.modal-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.modal-actions button {
  height: 34px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
}
.modal-actions .primary-btn {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
}
.main-body {
  padding: 16px;
}
</style>
